import { memo } from "react";
import Image from "next/image";
import clsx from "clsx";

import ratingLogo from "@public/rating.svg";
import s from "./styles.module.css";

interface RatingProps {
  isColorMuted?: boolean;
}

function Rating({ isColorMuted }: RatingProps) {
  return (
    <Image
      className={clsx(s.logo, isColorMuted && s.bw)}
      src={ratingLogo}
      alt="Sweat Wallet has a 4.7 star rating with 3400 reviews on app store"
    />
  );
}

export default memo(Rating);
